import { Link, useParams } from 'react-router-dom';
import { PageHeader } from '../../components/layout/page/PageHeader';
import { PageShell } from '../../components/layout/page/PageShell';
import { formatPortalDate } from './portalLabels';
import { usePortalState } from './PortalState';

export function PortalDocumentationPage() {
  const { pageId } = useParams();
  const { data } = usePortalState();
  const selected = data.documentation.find((page) => page.id === pageId) ?? data.documentation[0];

  return (
    <PageShell>
      <PageHeader
        title="Documentação"
        description="Manuais publicados para a Norte Atacado. Nesta pré-visualização há um guia da implantação."
      />
      <div className="grid gap-4 lg:grid-cols-[minmax(0,260px)_minmax(0,1fr)]">
        <ul className="erp-card divide-y divide-secondary-200">
          {data.documentation.map((page) => (
            <li key={page.id}>
              <Link
                to={`/portal/documentation/${page.id}`}
                className={`block px-4 py-3 ${selected?.id === page.id ? 'bg-primary-50' : 'bg-white'}`}
              >
                <span className="block text-sm font-semibold text-secondary-900">{page.title}</span>
                <span className="mt-1 block text-xs text-secondary-500">
                  Publicado em {formatPortalDate(page.publishedAt)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
        {selected ? (
          <article className="erp-card">
            <div className="erp-card-body">
              <h2 className="erp-card-title">{selected.title}</h2>
              <p className="erp-card-subtitle">{selected.summary}</p>
              <div className="mt-4 space-y-3">
                {selected.body.map((paragraph) => (
                  <p key={paragraph} className="text-sm text-secondary-800">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </article>
        ) : null}
      </div>
    </PageShell>
  );
}
